import { TMessage } from "../i18n/tt";
import { TMessageKey } from "../i18n/types.gen";

export enum DocumentType {
  notice_board_meeting = "notice_board_meeting",
  board_meeting = "board_meeting",
  notice_general_meeting = "notice_general_meeting",
  general_meeting = "general_meeting",
  subscription_form = "subscription_form",
  articlesofassociation = "articlesofassociation",
  custom_document = "custom_document",
}

const documentTypeLabels: { [key in DocumentType]: TMessageKey } = {
  [DocumentType.notice_board_meeting]: "document-type.notice_board_meeting",
  [DocumentType.board_meeting]: "document-type.board_meeting",
  [DocumentType.notice_general_meeting]: "document-type.notice_general_meeting",
  [DocumentType.general_meeting]: "document-type.general_meeting",
  [DocumentType.subscription_form]: "document-type.subscription_form",
  [DocumentType.articlesofassociation]: "document-type.articlesofassociation",
  [DocumentType.custom_document]: "document-type.custom_document",
};

export const isDocumentType = (o: unknown): o is DocumentType => String(o) in DocumentType;

export const getDocumentLabel = (t: DocumentType): TMessage => ({ key: documentTypeLabels[t] });

export const isGeneralMeetingDocumentType = (t: DocumentType): boolean =>
  t === DocumentType.notice_general_meeting || t === DocumentType.general_meeting;
